import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _TagDisplay;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { Tag } from '@instructure/ui-tag';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import { withStyleOverrides } from '@instructure/quiz-common';
export var TagDisplay = (_dec = withStyleOverrides(generateStyle, null), _dec(_class = (_TagDisplay = /*#__PURE__*/function (_Component) {
  function TagDisplay() {
    _classCallCheck(this, TagDisplay);
    return _callSuper(this, TagDisplay, arguments);
  }
  _inherits(TagDisplay, _Component);
  return _createClass(TagDisplay, [{
    key: "render",
    value: function render() {
      if (this.props.tagAssociations == null) {
        return null;
      }
      var display = this.props.display;
      var count = this.props.tagAssociations.size;
      var extra = count - display;
      var visible = this.props.tagAssociations.take(display).map(function (t) {
        return jsx(Tag, {
          margin: "0 xx-small 0 0",
          key: t.get('id'),
          text: t.get('tag_value')
        });
      });
      return jsx("div", {
        role: "group",
        css: this.props.styles.tags,
        "aria-label": t('question tags')
      }, visible, extra > 0 && jsx(Tag, {
        themeOverride: {
          defaultBackground: '#FFFFFF'
        },
        text: jsx(AccessibleContent, {
          alt: t('{n} other tags not shown', {
            n: extra
          })
        }, jsx(Text, {
          size: "small"
        }, t('+{n}', {
          n: extra
        })))
      }));
    }
  }]);
}(Component), _defineProperty(_TagDisplay, "displayName", 'TagDisplay'), _defineProperty(_TagDisplay, "componentId", "Quizzes".concat(_TagDisplay.displayName)), _defineProperty(_TagDisplay, "propTypes", {
  display: PropTypes.number,
  tagAssociations: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  styles: PropTypes.object
}), _defineProperty(_TagDisplay, "defaultProps", {
  display: 2,
  tagAssociations: null
}), _TagDisplay)) || _class);
export default TagDisplay;